// extracted by mini-css-extract-plugin
export default {"card_heading":"student-presence_card_heading__15oUP"};